import React from 'react';
import './index.scss';
import { HashRouter, useRoutes } from "react-router-dom";
import { createRoot } from 'react-dom/client';
import Home from './Home';
import ProjectPage from './ProjectPage';
import WritingPage from './WritingPage';
import Article from './Article';
import Contact from './Contact';
import About from './About';
import Project from './Project';
import LongformArticle from './LongformArticle';
import AquariumGame from './AquariumGame';

const App = () => {
  let routes = useRoutes([
    { path: "/", index: true, element: <Home /> },
    { path: "/projects", element: <ProjectPage /> },
    { path: "/projects/:projectId", element: <Project /> },
    { path: "/writing", element: <WritingPage /> },
    { path: "/writing/:articleId", element: <Article /> },
    { path: "/gallery/:articleId", element: <LongformArticle /> },
    { path: "/contact", element: <Contact /> },
    { path: "/about", element: <About /> },
    { path: "/aquarium", element: <AquariumGame /> },
    // // ...
  ]);
  return routes;
};

const container = document.getElementById('root');
document.title = "☀︎ solapowered"
document.description = "hi! i'm a software developer, designer, creative and maker of things"
const root = createRoot(container);
document.querySelector('meta[name="viewport"]').setAttribute('content', 'width=device-width, initial-scale=1');


root.render(
  <HashRouter>
    <App />
  </HashRouter>
);
